import React, { useEffect, useState } from "react";
import api from "../api";
import Header from "../components/Header";
import Hero from "../components/Hero";
import LogoMarquee from "../components/LogoMarquee";
import WhatsOn from "../components/WhatsOn";
import NearbyEvents from "../components/NearbyEvents";
import CategoryTiles from "../components/CategoryTiles";
import VoucherStores from "../components/VoucherStores";
import VideoMessages from "../components/VideoMessages";
import AdminTools from "../components/AdminTools";
import Fulfilment from "../components/Fulfilment";
import Support from "../components/Support";
import Integrations from "../components/Integrations";
import CaseStudies from "../components/CaseStudies";
import GrowCTA from "../components/GrowCTA";
import Blog from "../components/Blog";
import Footer from "../components/Footer";
import CookieBanner from "../components/CookieBanner";

export default function Landing() {
  const [content, setContent] = useState({});
  const [articles, setArticles] = useState([]);
  const [businesses, setBusinesses] = useState([]);

  useEffect(() => {
    api.get("/site-content").then(({ data }) => setContent(data)).catch(() => {});
    api.get("/articles").then(({ data }) => setArticles(data)).catch(() => {});
    api.get("/businesses/public").then(({ data }) => setBusinesses(data)).catch(() => {});
  }, []);

  const sec = (k) => content?.sections?.[k] !== false; // default visible

  return (
    <>
      <Header content={content} />
      <Hero content={content} />
      {sec("marquee") && <LogoMarquee businesses={businesses} />}
      {sec("nearby") && <NearbyEvents />}
      {sec("categories") && <CategoryTiles />}
      {sec("whatson") && <WhatsOn />}
      {sec("features") && (
        <section id="features">
          <VoucherStores content={content} />
          <VideoMessages content={content} />
          <AdminTools content={content} />
          <Fulfilment content={content} />
          <Support content={content} />
        </section>
      )}
      {sec("integrations") && <Integrations content={content} />}
      {sec("clients") && (
        <section id="clients">
          <CaseStudies content={content} />
        </section>
      )}
      {sec("pricing") && (
        <section id="pricing">
          <GrowCTA content={content} />
        </section>
      )}
      {sec("blog") && <Blog content={content} articles={articles} />}
      <Footer content={content} />
      <CookieBanner />
    </>
  );
}
